// extracted by mini-css-extract-plugin
export var button = "ShareModalDrawerTextMessage-module__button___e3xW1";
export var disabled = "ShareModalDrawerTextMessage-module__disabled___Pgy8S";
export var form = "ShareModalDrawerTextMessage-module__form___QHjX1";
export var loading = "ShareModalDrawerTextMessage-module__loading___KA6MZ";
export var phone = "ShareModalDrawerTextMessage-module__phone___qKyzs";